/* eslint-disable linebreak-style */
import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.feature-card',
        openModalButton: '.feature-card-overlay-open--dynamic',
        modal: '.general-overlay',
        modalDialog: '.general-overlay__dialog',
        video: '.feature-card__image-wrapper--video .video-js',
        iconPlay: '.icon-play',
        iconMute: '.icon-mute',
    },
    classNames: {
        modalDialog: '.general-overlay__dialog',
        video: '.feature-card__image-wrapper--video .video-js',
        iconPlay: '.icon-play',
        iconPause: 'icon-play--pause',
        iconMute: '.icon-mute',
        iconMuted: 'icon-mute--muted',
    },
    dataAttributes: {
        index: 'index',
        href: 'href',
        autoplay: 'autoplay',
        muted: 'muted',
    },
};
class FeatureCard {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
        this._loadmore = false;
    }

    init() {
        this._elements = this._getDomElements();
        this._addEventListeners();

        // eslint-disable-next-line no-restricted-syntax
        for (const videoSettings of this._elements.$video) {
            if (videoSettings) {
                this._addVideoEventListeners(videoSettings);
            }
        }
    }

    _getDomElements() {
        return {
            $openModalButton: this._$rootElement.find(
                config.selectors.openModalButton,
            ),
            $modal: this._$rootElement.find(config.selectors.modal),
            $video: this._$rootElement.find(config.selectors.video),
        };
    }

    _addEventListeners() {
        const mountedApps = [];
        // eslint-disable-next-line func-names
        this._elements.$openModalButton.on('click keypress', function (event) {
            // eslint-disable-next-line space-in-parens
            if ( event.type === 'click' || (event.type === 'keypress' && (event.key === 'Enter' || event.keyCode === 13))) {
                const featureCardID = $(this).data('target').replace('#cardOverlay-', '');
                let alreadyActivated = false;
                const target = $(this).data('target');

                mountedApps.forEach((init) => {
                    if (init === featureCardID) {
                        alreadyActivated = true;
                    }
                });

                if (alreadyActivated) {
                    console.log('already activated', featureCardID);
                    $(target).modal('show');
                } else {
                    if (!featureCardID) {
                        return;
                    }

                    const $modalContentSource = $(`#cardOverlayContent-${featureCardID}`);
                    if (!$modalContentSource.length) {
                        return;
                    }

                    const data = $modalContentSource.html();
                    $modalContentSource.html('');
                    if (!data.trim()) {
                        return;
                    }

                    if (!target || !$(target).length) {
                        return;
                    }

                    const $modalContent = $(target).find(config.classNames.modalDialog);
                    mountedApps.forEach((init) => {
                        if (init === featureCardID) {
                            alreadyActivated = true;
                        }
                    });

                    $modalContent.html(data);
                    console.log('not activated', featureCardID);

                    mountedApps.push(featureCardID);
                    $modalContent.promise().done(() => {
                        const hasForm = $modalContent[0].querySelector('.overlay-form');
                        if (hasForm) {
                            console.log('hasForm', featureCardID);
                            window.dispatchEvent(
                                new CustomEvent('FormAppInit', {
                                    detail: { overlay: `cardOverlay-${featureCardID}` },
                                }),
                            );
                        } else {
                            console.log('hasForm', false);
                        }
                        $(target).modal('show');
                    });
                }
            }
        });
    }

    _addVideoEventListeners(video) {
        const _this = this;
        const playIcon = _this._$rootElement.find(config.selectors.iconPlay);
        const muteIcon = _this._$rootElement.find(config.selectors.iconMute);

        video.player.on('ended', () => {
            video.player.play();
        });

        video.player.on('play', () => {
            playIcon.addClass(config.classNames.iconPause);
        });

        video.player.on('pause', () => {
            playIcon.removeClass(config.classNames.iconPause);
        });

        playIcon.on('click', () => {
            if (playIcon.hasClass(config.classNames.iconPause)) {
                video.player.pause();
            } else {
                video.player.play();
            }
        });

        muteIcon.on('click', () => {
            if (muteIcon.hasClass(config.classNames.iconMuted)) {
                video.player.muted(false);
            } else {
                video.player.muted(true);
            }
        });

        if (this._elements.$video.data(config.dataAttributes.autoplay)) {
            video.player.muted(true);
            video.player.play();
        }
    }
}

moduleRegistry.registerModule('FeatureCard', FeatureCard);
moduleRegistry.autoApplyModule('FeatureCard', config.selectors.root);
